<cm-inspector-section>
    <ng-container cm-title> Visibility</ng-container>
    <ng-container cm-content>
        <cm-toggle [toggle]="$showGuides()" (toggleChange)="setShowGuides($event)" [disabled]="$disabled()">
            <ng-container cm-text><span [class.cm-disabled]="$disabled()">Show guides </span></ng-container>
        </cm-toggle>
    </ng-container>
</cm-inspector-section>
